import { useRouter } from 'expo-router'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'
import { ScrollView } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Icon } from '@/src/elements/media/Icon'
import { Typography } from '@/src/elements/text/Typography'
import { PrayRewardCitation } from '@/src/features/pray/ui/components/PrayRewardCitation/PrayRewardCitation'
import { useXMRPMRedirect } from '@/src/features/rosario/services/useXMRPMRedirect'
import { ICON } from '@/src/general/enums/icons'
import { useRoutes } from '@/src/general/utils/routes'

import { useWatchmanRewardOnFinish } from './useWatchmanRewardOnFinish'

export const WatchmanIntentionsRewardScreen = (): ReactNode => {
  const router = useRouter()
  const { routes } = useRoutes()

  const onFinish = useWatchmanRewardOnFinish()
  const prayForMoreRedirect = useXMRPMRedirect({ destination: routes.intentions() })

  return (
    <ScrollView contentContainerClassName="web:items-center h-full">
      <View className="w-full max-w-md gap-6 p-6 pb-12 web:min-h-screen native:min-h-full justify-between">
        <View className="items-center gap-2 pt-12">
          <Icon
            name={ICON.LANTERN}
            className="web:h-16 web:w-16 native:min-w-16 native:min-h-16 text-primary-icon-contrast-lower"
          />
          <Typography bold center colors="primary" contrast="high" size="xl">
            <FormattedMessage id="thanks.prayed.watchman.intentions" />
          </Typography>
        </View>
        <View className="max-h-1/2">
          <PrayRewardCitation />
        </View>
        <View className="gap-4">
          <Button fullWidth onPress={() => router.navigate(prayForMoreRedirect)} variant="faded" colors="primary">
            <FormattedMessage id="watchman.daily.pray-for-more" />
          </Button>
          <Button fullWidth onPress={onFinish} variant="solid" colors="primary">
            <FormattedMessage id="word.finish" />
          </Button>
        </View>
      </View>
    </ScrollView>
  )
}
